<template>
  <div class="header-main">
    <div class="header-wrap">
      <div class="grid-container header-container">
        <div class="header-grid">
          <div class="content-wrap">
            <img src="../assets/remix_header.svg" alt="Marketing Remix" class="header-img">

            <div class="title-wrap">
              <div class="title">
                <h2>An Interactive Marketing Assessment Tool</h2>
              </div>
            </div>
          </div>

          <div class="powered-by">
            <img src="../assets/powered_by_wmk.svg" alt="powered by wmk logo" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars';
@import '../assets/scss/mixins';

.header-main {
}

.header-wrap {
  // overflow-x: hidden;
  z-index: 10;
  // margin-bottom: -17%;
  // margin-bottom: gu(-16.5);
}

.header-container {
  @media screen and (min-width: 40rem) {
    padding-left: gu(2);
    padding-right: gu(2);
  }
}

.header-grid {
  position: relative;
}

.content-wrap {
  position: relative;
  display: inline-block;
  margin-bottom: gu(1);

  @media only screen and (min-width: 40rem) {
    margin-bottom: -15.5%;
  }

  &::before, &::after {
    content: '';
    position: absolute;
    top: 0;
    height: 67.04%;
    background-color: $white;
  }

  $edge-width: calc( calc( calc( 100vw - #{$global-width} ) / 2 ) + #{gu(2)} );
  &::before {
    right: 100%;
    width: gu(6);

    @media only screen and (min-width: $global-width) {
      width: $edge-width;
    }
  }

  &::after {
    left: 100%;
    width: calc( 100vw - 100% - #{gu(2)} );

    @media only screen and (min-width: $global-width) {
      width: calc( calc( #{$global-width} - 100% - #{gu(4)} ) + #{$edge-width} );
    }
  }
}

.header-img {
  max-width: 61vw;
  margin-left: rem-calc(-1);
  margin-right: rem-calc(-1);
  // z-index: 10;
}

.title-wrap {
  position: absolute;
  top: 0;
  height: 67.04%;
  left: 0;
  width: 100%;
}

.title {
  position: relative;
  height: 100%;

  h2 {
    position: absolute;
    bottom: 38%;
    left: 84%;
    font-size: 4vw;
    color: $colGray;
    font-weight: $fwBold;
    width: 37vw;
    max-width: rem-calc(485);
    margin-bottom: 0;
    text-align: left;
    line-height: 1.125;
    z-index: 10;

    @media only screen and (min-width: 40rem) {
      width: 41vw;
    }

    @media only screen and (min-width: rem-calc(1133)) {
      font-size: rem-calc(45);
    }
  }
}

.powered-by {
  position: absolute;
  top: gu(1);
  right: 0;
  // width: rem-calc(200);

  @media only screen and (min-width: 40rem) {
    top: gu(2);
  }

  img {
    max-width: 38vw;
  }
}

</style>
